import { format } from 'date-fns';
import { sports } from '../../../../components/Util/enum';

/**
 * Una richiesta di adesione (membership non ancora confermata) come la mostrano la lista Richieste e
 * la sua scheda. `element` è una voce di useMemberships.
 */
export const rigaRichiesta = (element) => {
	const image = element.picture && element.picture.uri ? element.picture.uri : null;

	let tipologia_desc = '';
	if (element.membershipRank === 'MEMBER') tipologia_desc = 'Socio';
	else if (element.membershipRank === 'COACH') tipologia_desc = 'Staff tecnico';
	else if (element.membershipRank === 'DIRECTOR') tipologia_desc = 'Cda';

	let status_desc = '';
	let status_class = '';
	if (element.status === 'PENDING') {
		status_desc = 'In attesa';
		status_class = 'text-warning';
	} else if (element.status === 'CONFIRMED') {
		status_desc = 'Confermata';
		status_class = 'text-success';
	} else if (element.status === 'DECLINED') {
		status_desc = 'Rifiutata';
		status_class = 'text-danger';
	}

	const verso = element.invitationType === 'USER_TO_CLUB' ? 'Ricevuta' : 'Inviata';

	const sportKey = element.sport || (element.member && element.member.sportType) || (element.coach && element.coach.sportType) || (element.guru && element.guru.sportType) || null;
	const sport_decode = sportKey ? (sports.find(s => s.value === sportKey)?.label || '') : '';

	return {
		id: element.id,
		membershipRank: element.membershipRank,
		userId: element.userId,
		date: format(element.createdAt, 'dd/MM/yyyy HH:mm:ss'),
		name: element.name,
		imageUrl: image,
		type: tipologia_desc,
		sport: sport_decode,
		sportType: sportKey,
		status: { label: status_desc, class: status_class },
		invitationType: element.invitationType,
		verso,
	};
};
